export enum C3HardwareItemType {
    
    // things requested by other departments like
    // roof racks, running boards, trailers,
    // axle rods and axle assemblies
    SeljanSupplied = 'seljan supplied',

    // electrical components like control panels,
    // remotes, speakers, headlights, chargers,
    Electronics = 'electronics',

    Motors = 'motors',

    Fastener = 'fasteners',

    Miscellaneous = 'miscellaneous'
}